define("auth/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('login');
    this.route('reset_password');
    this.route('signup', function () {
      this.route('welcome');
    });
    this.route('accept_invite', {
      path: '/accept_invite/:invitation_token'
    });
    this.route('accept_membership', {
      path: '/membership/:membership_id'
    });
    this.route('update_password');
    this.route('o-auth', {
      path: '/oauth/later_authorize'
    });
    this.route('profile-refresh-popup', {
      path: '/oauth/popup/:name'
    });
    // OCE Mavrck user onboarding
    this.route('campaign', {
      path: '/:campaign_id'
    }, function () {
      this.route('login');
      this.route('signup');
    });
  });
});